module.exports = __webpack_public_path__ + "static/media/success-purple.c344402e.svg";